import { handleActions } from 'redux-actions';

const INITIAL_STATE = {
  dogs: [],
};

const DOG_INITIAL_STATE = { //eslint-disable-line
  name: '',
  breed: '',
  dogsize: '',
  about: '',
  date_of_birth: '',
  good_with_children: false,
  plays_with_other_dogs: false,
  registration: '',
  needs: [],
  interests: [],
  health_needs: '',
  hypoallergenic_coat: false,
  image_url: '',

  sex: null,
  fixed: null,
};

const dogs = handleActions(
  {
    UPDATE_DOGS: (state, action) => Object.assign({}, state, action.payload),
    LOGOUT: INITIAL_STATE,
  },
  INITIAL_STATE,
);

export default dogs;



// WEBPACK FOOTER //
// ./src/reducers/dogs.js